import React from "react";
import type { LinkButtonProps } from "../../../react4xp/shared/LinkButton/LinkButton.d";

import { LinkButton } from "../../../react4xp/shared/LinkButton/LinkButton";

export default function(props: Readonly<LinkButtonProps>) {
  return <LinkButton {...props} />;
}
